import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import React__default, { useCallback } from "react";
import { FileInputWUT } from "../../inputs/file-input/file-input-wut.js";
import { useFieldAttributes } from "../../services/field-attributes.js";
import { FieldDescriptionWUT } from "../field-description/field-description-wut.js";
import { FieldErrorWUT } from "../field-error/field-error-wut.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import { Widget } from "../widget/widget.js";
import { useFileUploadController } from "./use-file-upload-controller.js";
import { useFileUpload } from "../autocomplete/wut/FileUpload/useFileUpload.js";
import { FileUploadDetails } from "../autocomplete/wut/FileUpload/FileUploadDetails.js";
const FileUploadWUT = ({
  id,
  target,
  label,
  description,
  value,
  onChange,
  onFocus,
  onBlur,
  error,
  disabled = false,
  buttonText,
  uploadFileFormats,
  valueSliderLimit,
  required,
  hideLabel,
  hideAsterisk,
  explanationText,
  FieldLayout,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  hasError = false,
  errorMessage,
  widgetHtml,
  widgetEnabled
}) => {
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  const fileUploadButtonRef = React__default.useRef(null);
  const handleFilesCleared = useCallback(() => {
    fileUploadButtonRef.current?.focus();
  }, []);
  const {
    files,
    _error,
    hover,
    getExplanationText,
    handleChange,
    handleDelete,
    accept,
    handleBlur
  } = useFileUploadController({
    valueSliderLimit,
    value,
    explanationText,
    target,
    onChange,
    uploadFileFormats,
    onBlur,
    onFilesCleared: handleFilesCleared
  });
  const { fileInputRef, textBelowButtonRef, fileErrorMessage } = useFileUpload({
    files
  });
  const _errorMessage = fileErrorMessage || _error || errorMessage;
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          htmlFor: inputId,
          required,
          label,
          hideLabel,
          requiredIndicatorHidden: hideAsterisk,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        FileInputWUT,
        {
          onFocus,
          onBlur: handleBlur,
          disabled,
          buttonText,
          valueSliderLimit,
          required,
          inputId,
          ariaLabelledBy: labelId,
          ariaDescribedBy,
          files,
          hover,
          handleChange,
          accept,
          fileInputRef,
          fileUploadButtonRef,
          textBelowButtonRef,
          hasError,
          fieldId: id
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FileUploadDetails,
          {
            fileInputRef,
            textBelowButtonRef,
            files,
            onDeleteClick: handleDelete,
            hasError: Boolean(_errorMessage),
            explanationText: getExplanationText()
          }
        ),
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError: Boolean(_errorMessage),
            errorMessage: _errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  FileUploadWUT
};
//# sourceMappingURL=file-upload-wut.js.map
